<template>
	<main-masterpage>
		<div class="hello">
			<div class="sector">
				<p>Протягом багатьох років з’явилаяся спільнота лікарів, дієтологів та нутриціологів, які у своєї практиці
					застосовують
					в програмах лікування та профілактики широкого спектру захворювань фітопрепарати та нутрицевтики. Ця
					практика
					базується на багаторічному досвіді досягнення позитивних результатів та схвальних відгуках пацієнтів.</p>
				<p>На даному сайті представлений неповний перелік засобів, які були відібрані даною спільнотою лікарів,
					дієтологів
					та
					нутриціологів на підставі відповідності критеріям ціна - якість. Надані нутрицевтики та фітопрепарати
					представлені
					на
					ринку України великою кількістю компаній-виробників. Але наша спільнота спеціалістів у своєї багаторічної
					практиці
					зупинила свій вибір на компанії NOW Foods, США саме за найкращу відповідність критеріям ціна-якість,
					акцентуючи
					увагу
					саме на гарантії якості, та великої кількості позитивних результатів застосування.</p>
				<p>Представлені на сайті засоби вироблені з застосуванням високоефективних сучасних технологій та є
					беспечними
					у
					широкому діапазоні разових та добових дозувань, а також не мають побічних ефектів та є гіпоалергенними.
					Поставки здійснюються <strong>ВИКЛЮЧНО</strong> із США. Представлена продукція пройшла всі необхідні
					перевірки
					в
					США і там
					же отримала
					сертифікати якості. Після такої ретельної перевірки всі товари, які були сертифіковані в країнах ЄС або в
					США,
					повторної сертифікації на території України не потребують (відповідно до закону України). Ми зацікавлені
					у
					досягненні
					позитивного результату та піклуємося про здоров’я наших пацієнтів, тому застосовуємотільки якісні засоби.
				</p>
			</div>
			<div class="sector2">
				<p>Протягом багатьох тисячоліть ліками для людини служили рослини, окремі органи та частини тварин, грунт та
					мінерали.</p>
				<p>Наприкінці XVIII століття підчас розробки лікарських форм поперше з природної лікарської сировини
					відокремлювались
					окремі діючи компоненти, далі вивчалася їх молекулярна будова, та нарешті здійснювався хімічний сінтез
					фармакологічних препаратів.</p>
				<p>Такий підхід є основою сучасної фармакології, у стані якої лікарі-спеціалісти та загальне суспільство
					обізнані
					достатньою мірою.
					Протягом останніх десятиріч помічається значне зростання алергічних та токсічних ускладнень терапії з
					застосуванням
					ліків та сучасних фармакологічних засобів. Тільки у США щорічно з приводу різноманітних проявлень
					лікарської
					хвороби
					за медичною допомогою звертається близько 1 млн. пацієнтів. У зв’язку з поширенням негативних наслідків
					лікування
					сінтетичними фармакологічними препаратами виникла необхідність пошуку нових ефективних та водночас
					безпечних
					лікувально-профілактичних засобів.</p>
				<p>На межі класичної фармакології та дієтології з’явився та інтенсивно розвинувся новий науковий напрям -
					фармаконутриціологія. Фармаконутриціологія займається пошуком та вивченням біологічно активних речовин
					природного
					походження. Таким чином з’явилися нутрицевтики (фітопрепарати, БАД, екстракти лікарських рослин,
					препарати,
					які
					містять біологічно активні речовини тваринного походження).
					Нутрицевтики - засоби поповнення дефіциту есенціальних (незамінних, тобто таких, які не сінтезуються
					організмом
					людини та отримуються тільки з їжею) факторів живлення: вітімінів та вітаміноподібних речовин, макро- та
					мікроелементів, поліненасичених жирних кислот, амінокислот, клітковини. Ці засоби виробляються із
					застосуванням
					сучасних технологій, можуть застосовуватись постійно з ціллю профілактики без побічних ефектів, зазвичай
					не
					мають
					протипоказань.</p>
			</div>
		</div>
		<header-ads />
	</main-masterpage>
</template>

<script>
import MainMasterpage from '@/masterpages/MainMasterpage.vue';
import HeaderAds from '@/components/HeaderAds.vue';
export default {
	name: "HomeView",
	components: { MainMasterpage, HeaderAds },
	metaInfo() {
		return {
			title: 'Now Foods - витамины',
			meta: [
				{ name: 'description', content: 'Магазин нутрициология, фитотерапия, диетология с доставкой по Украине.' }
			]
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.hello {
	display: flex;
	gap: 20px;
}

@media (max-width:580px) {
	.hello {
		display: flex;
		flex-direction: column;
		gap: 20px;
	}
}

p {
	color: rgb(1, 41, 1);
	font-size: 16px;
	font-weight: 500;
	letter-spacing: 0.5px
}

.sector,
.sector2 {
	border: 2px solid green;
	border-radius: 15px;
	padding: 10px;
	line-height: 1.3;
	display: block;
	position: relative;
}

.sector::after {
	content: "";
	background: url("../assets/white2.jpg") 0 0 / cover no-repeat;
	opacity: 0.1;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	position: absolute;
	border-radius: 15px;
	z-index: -1;
}

.sector2::after {
	content: "";
	background: url("../assets/lif.jpg") 0 0 / cover no-repeat;
	opacity: 0.1;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	position: absolute;
	border-radius: 15px;
	z-index: -1;
}
</style>
